// Main global shared styles //
//////////////////////////////

import SVG from 'react-inlinesvg';
import styled from 'styled-components';

// Colors

export const Colors = {
  cerulean: '#15C7FF',
  lightDenim: '#128BD8',
  denim: '#1163BF',
  darkDenim: '#3E506F',
  blackPearl: '#082141',
  white: '#FFFFFF',
  lightMystic: '#F8FAFC',
  athensGrey: '#E2E8EE',
  darkMystic: '#DBE8EB',
  towerGrey: '#C5D7DC',
  heatherGrey: '#B8C4D1',
  chateauGrey: '#9DA8B2',
  periwinkleGrey: '#80989E',
  darkGrey: '#444',
  black: '#000000',
  landingYellow: '#DCFA35',
  colorDanger: '#A94442',
  colorLoading: '#80989E',
  colorWarning: '#F89F42',
  colorSuccess: '#0DB45D',
  inputFocus: 'rgba(17, 99, 191, .05)',
  inputError: 'rgba(248, 159, 66, .05)',
  inputErrorOpaque: 'rgba(248, 159, 66, .15)',
  inputWarning: 'rgba(248, 159, 66, .05)'
}

// Buttons
export const Button_s = styled.button`
  border: 2px solid;
  border-radius: 2px;
  // box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  cursor: ${props => props.disabled ? 'cursor: not-allowed' : 'pointer'};
  font-size: 14px;
  font-weight: 300;
  height: 30px;
  opacity: ${props => props.disabled ? '0.5' : '1'};
  padding: 0 8px;
  transition: transform 0.1s ease-in-out, box-shadow 0.1s ease-in-out;
  &.depress {
    &:active {
      transform: translateY(.2px) scale(0.97);
    }
  }
  &:focus {
    outline: none;
  }
  ${props => {
    if (props.primary) {
      return `
        background: ${Colors.denim} !important;
        border-color: ${Colors.denim} !important;
        color: ${Colors.white} !important;
        &:hover {
          background: ${Colors.denim};
          color: ${Colors.white};
        }
      `
    } else if (props.success) {
      return `
        background: ${Colors.colorSuccess};
        border-color: ${Colors.colorSuccess} !important;
        &:hover {
          background: ${Colors.colorSuccess};
          color: ${Colors.white};
        }
      `
    } else if (props.warning) {
      return `
        background: ${Colors.colorWarning};
        border-color: ${Colors.colorWarning} !important;
        &:hover {
          background: ${Colors.colorWarning};
          color: ${Colors.white};
        }
      `
    } else if (props.danger) {
      return `
        color: ${Colors.white} !important;
        background: ${Colors.colorDanger} !important;
        border-color: ${Colors.colorDanger} !important;
        &:hover {
          background: ${Colors.colorDanger};
          color: ${Colors.white};
        }
      `
    } else {
      // button is 'default'
      return `
        background: ${Colors.white} !important;
        border-color: ${Colors.towerGrey} !important;
        color: ${Colors.blackPearl} !important;
        &:hover {
          background: ${Colors.white};
          color: ${Colors.blackPearl};
        }
      `
    }
  }}
`

export const ButtonWithPress_s = styled(Button_s)`
  overflow: hidden;
  position: relative;
  transition-duration: 0.4s;
  text-decoration: none;
  &:hover {
    box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
  }
  &:after {
    content: "";
    background: ${Colors.white};
    display: block;
    position: absolute;
    padding-top: 300%;
    padding-left: 350%;
    margin-left: -20px!important;
    margin-top: -120%;
    outline: none;
    opacity: 0;
    transition: all 0.4s
  }
  :active:after {
    padding: 0;
    margin: 0;
    opacity: 1;
    transition: 0s
  }
`

// Headers
export const H4 = styled.h4`
  color: ${Colors.darkDenim};
  font-family: 'Roboto-Light', sans-serif;
  font-size: 16px;
  font-weight: 400;
`

// Labels
export const Label_s = styled.label`
  color: ${props => {
    if (props.primary) return `${Colors.blackPearl};`
    else if (props.danger) return `${Colors.colorDanger} !important;`
    else if (props.warning) return `${Colors.colorWarning} !important;`
    else return `${Colors.blackPearl};`
  }}
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 10px;
`

// Links

export const Link_s = styled.a`
  color: ${Colors.cerulean} !important;
  cursor: pointer;
  font-size: 14px !important;
`

// SVGs
export const Svg_s = styled(SVG)`

`

export const Container_s = styled.div`
  height: 100%;
`
export const Content_s = styled.div`
  min-height: 100vh;
  overflow: auto;
  padding-top: 75px;
  position: absolute;
  width: calc(100% - 90px);
`

// Summary bar at bottom of pages

export const ContentSummary_s = styled.div`
  align-items: center;
  background: #F3F7FC;
  border-top: 1px solid ${Colors.towerGrey};
  bottom: 0;
  color: ${Colors.blackPearl};
  display: flex;
  flex-direction: row;
  font-family: 'Roboto', sans-serif;
  height: 30px;
  left: 90px;
  padding: 2px 15px;
  position: fixed;
  width: 100%;
  z-index: 99;
`